import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import clsx from "classnames";
import { useStyles } from "./BottomTabBar.style";
import { Icon } from "../../core/Icon/Icon";
import { PageRoutes } from "../../../constants/routes";
import { useTranslation } from "react-i18next";
import { useIsKidProfile } from "../../../hooks/useProfileSession";

const tabs = [
  {
    icon: "icon-bold-console",
    path: PageRoutes.Home,
    labelKey: "Navigation_Console",
  },
  {
    icon: "icon-gamepad-bold",
    path: PageRoutes.EssentialPass,
    labelKey: "Navigation_Essential Pass",
  },
  {
    icon: "icon-bold-game-store",
    path: PageRoutes.InstallGame,
    labelKey: "Navigation_Install & Play",
  },
  {
    icon: "icon-bold-search-normal",
    path: PageRoutes.Search,
    labelKey: "Navigation_Search",
  },
  {
    icon: "icon-setting",
    path: PageRoutes.Settings,
    labelKey: "Navigation_Settings",
  },
];

export const BottomTabBar: FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isKid = useIsKidProfile();
  const visibleTabs = isKid
    ? tabs.filter((tab) => tab.path !== PageRoutes.InstallGame)
    : tabs;

  return (
    <div className={classes.root}>
      {visibleTabs.map((tab) => (
        <div
          key={tab.path}
          className={clsx(classes.item, {
            [classes.itemActive]: location.pathname === tab.path,
          })}
          data-selected-class={classes.selected}
          data-gamepad={`menu-${tab.path}`}
          role="button"
          tabIndex={-1}
          aria-label={t(tab.labelKey)}
          aria-current={location.pathname === tab.path ? "page" : undefined}
          onClick={() => navigate(tab.path)}
        >
          <Icon name={tab.icon} size={24} />
        </div>
      ))}
    </div>
  );
};
